__turbopack_context__.v({
  "content": "ProfileTemplates-module-scss-module__qmRnQG__content",
  "galleryGridList": "ProfileTemplates-module-scss-module__qmRnQG__galleryGridList",
  "gridContainer": "ProfileTemplates-module-scss-module__qmRnQG__gridContainer",
  "isLess": "ProfileTemplates-module-scss-module__qmRnQG__isLess",
  "isMore": "ProfileTemplates-module-scss-module__qmRnQG__isMore",
  "loadedTemplatesLength": "ProfileTemplates-module-scss-module__qmRnQG__loadedTemplatesLength",
  "mobileView": "ProfileTemplates-module-scss-module__qmRnQG__mobileView",
  "showMoreLessButtonIcon": "ProfileTemplates-module-scss-module__qmRnQG__showMoreLessButtonIcon",
  "templateCardNoBorderRadius": "ProfileTemplates-module-scss-module__qmRnQG__templateCardNoBorderRadius",
  "threeInRow": "ProfileTemplates-module-scss-module__qmRnQG__threeInRow",
});
